import styled, { keyframes } from 'styled-components';
import { GRADIENT } from '../../../constant-styles';

const slideRight = keyframes`
  from {
	transform: translateX(0);
  }
  to {
	transform: translateX(10px);
  }
`;

export const AnimationContainer = styled.div<{ isActive: boolean }>`
	display: inline-block;
	animation: ${({ isActive }) => (isActive ? slideRight : 'none')} 0.5s forwards;
`;

export const FadeContainer = styled.div<{ numberOfModels: number }>`
	display: flex;
	align-items: center;
	pointer-events: none;

	margin: 20px 0;
	overflow: hidden;
	-webkit-mask: ${GRADIENT.TRANSPARENT};
	mask: ${GRADIENT.TRANSPARENT};

	// Tablet size
	@media screen and (min-width: 960px) and (max-width: 1199px) {
		height: 40vh;
		padding: 5vh 0; // Centrar verticalmente
	}

	@media screen and (min-width: 1200px) {
		height: 65vh;
		padding: 15vh 0; // Centrar verticalmente
	}

	@media screen and (min-width: 1600px) {
		height: 80vh;
		padding: 5vh 0; // Centrar verticalmente
	}
`;

export const Model = styled.li`
	padding-bottom: ${(props) => props.theme.size.static150};
`;

export const ModelsList = styled.ul`
	transition: margin-top 1s ease; // Define la animación para marginTop
	pointer-events: auto;

	@media screen and (max-width: 959px) {
		display: none;
	}

	// Tablet size
	@media screen and (min-width: 960px) and (max-width: 1199px) {
		max-height: 25vh;
	}

	@media screen and (min-width: 1200px) and (max-width: 1599px) {
		max-height: 55vh;
	}

	@media screen and (min-width: 1600px) {
		max-height: 65vh;
	}
`;

export const ModelListContainer = styled.div`
	width: 40vw;
	left: 50px;
	position: relative;
	z-index: 2;
	pointer-events: none;

	@media screen and (max-width: 959px) {
		left: 0;
		width: 100vw;
		overflow: visible;
		pointer-events: auto;
	}

	// Tablet size
	@media screen and (min-width: 960px) and (max-width: 1199px) {
		left: 0;
		width: 80vw;
		overflow: visible;
	}
`;

export const RelativeContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;

	position: relative;
`;

export const TrackingContainer = styled.div`
	pointer-events: auto;
	cursor: pointer !important;
`;
